import axios from "axios";
import { authHeaderFile, authHeaderJson } from "../auth-header.service";

const getDocumentListByMessage = (messageId) => {
    return axios.get(`/api/sbMessage/messageDocument/${messageId}/list`, { headers: authHeaderJson() } )
};

const getDocumentListByBook = (bookId, partyMemberId) => {
    return axios.get(`/api/sbBook/bookDocument/${bookId}/${partyMemberId}/list`, { headers: authHeaderJson() } )
};

const addDocumentByMessage = (messageDocument) => {
    return axios.post(`/api/sbMessage/messageDocumentadd`, messageDocument, { headers: authHeaderJson() } )
};
const addListDocumentByMessage = (messageId, messageDocumentList) => {
    return axios.put(`/api/sbMessage/messageDocument/${messageId}/list`, messageDocumentList, { headers: authHeaderJson() } )
};

const addTransversalDocument = async (formData) => {
    return axios.post('/transversalDocumentadd', formData, { headers: authHeaderFile() });
};


const bookDocumentaddGetUrl = async (book_id, filename) => {
    return axios.post(`/api/sbBook/bookDocumentadd/getUrl`, {id: book_id, filename: filename}, { headers: authHeaderJson() } )
};

const bookDocumentadd = async (book_id) => {
    return axios.post(`/api/sbBook/bookDocumentadd/${book_id}`, null, { headers: authHeaderJson() } )
};



const downloadDocumentsByIds = (documentIdList) => {
    return axios.post(`/api/sbBook/bookDocumentsDownload`, documentIdList, { headers: authHeaderJson() } )
};
const removeDocumentByMessageDocument = (documentId, messageId) => {
    //[#REVISAR#]
    return axios.delete(`/api/sbMessage/messageDocumentLinkRemove/${messageId}/${documentId}`, { headers: authHeaderJson() } )
};

export {
    getDocumentListByMessage,
    getDocumentListByBook,
    addTransversalDocument,
    bookDocumentaddGetUrl,
    bookDocumentadd,
    addDocumentByMessage,
    removeDocumentByMessageDocument,
    addListDocumentByMessage,
    downloadDocumentsByIds
}